import React from "react";

export default function Redacted({ children }) {
    return (
        <span
            data-testid="redaction-toggle-bar"
            tabIndex={0}
            className="group/red relative cursor-pointer select-none rounded-sm px-1 align-baseline bg-[#17171c] text-transparent border-b border-amber/50 transition-colors duration-300 hover:bg-amber/90 focus:bg-amber/90 focus:outline-none hover:text-ink focus:text-ink"
            title="Hover to declassify"
        >
            <span
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 flex items-center justify-center font-mono text-[10px] uppercase tracking-widest text-amber/70 group-hover/red:opacity-0 transition-opacity"
            >
                Declassify
            </span>
            <span className="opacity-0 group-hover/red:opacity-100 focus:opacity-100 transition-opacity duration-300">
                {children}
            </span>
        </span>
    );
}
